import * as R from 'ramda'

import installModel from './db/installClient.js'
import installUI from './ui/installClient.js'

export default R.pipe(installModel, installUI)
